import { PaneHeader } from '@/components/settings/pane-header';
import { ClinicVisibilityEditor } from '@/components/settings/clinic-visibility-editor';
import { ScrollArea } from '@/components/ui/scroll-area';

// Hosts the clinics × surfaces visibility table. Like its SHARED siblings it has no RBAC
// `requires`; the editor resolves canEdit from the payload (settings:manage, server-side).
export function ClinicVisibilitySubPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PaneHeader
        title="Clinic visibility"
        description="Choose where each clinic appears — e.g. keep a technical tenant off the Work Plan. Shared with your whole team."
      />
      <ScrollArea className="min-h-0 flex-1" viewportClassName="p-6">
        <div className="mx-auto max-w-3xl">
          <ClinicVisibilityEditor />
        </div>
      </ScrollArea>
    </div>
  );
}
